module.exports = __webpack_public_path__ + "static/08-3577351ca5b9a3da670c3ebab3dcd1a6.jpg";